import React from 'react';

import { GamepadIcon } from '../icons';
import styles from './GameBadge.module.scss';

type GameBadgeProps = {
  name: string;
};

export default function GameBadge({ name }: GameBadgeProps) {
  if (!name) return null;
  return (
    <div className={styles.badge}>
      <GamepadIcon />
      <span className={styles.name}>{name}</span>
    </div>
  );
}
